import messages from './Utilisateur.json'

export default {
  name: "Utilisateur",
  i18n: messages,

  props: ['user', 'enCours'],

  data() {
    return {
     
    }
  }
}
